import { Grid, Tab, Tabs, styled } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useMemo } from "react";

const tabs = [
  {
    text: "Withdraw",
    value: "withdraw",
  },
  {
    text: "Deposit",
    value: "deposit",
  },
];

export function DepositOrWithdrawTab() {
  let navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const handleChangeTab = (_, tab) => {
    navigate(`/${tab}/${params.id}`);
  };

  const currentTab = useMemo(() => {
    const current = tabs.find((tab) => location.pathname.includes(tab.value));

    return current?.value;
  }, [location]);

  return (
    <Grid item xs={12}>
      <TabsStyle
        value={currentTab}
        onChange={handleChangeTab}
        aria-label="secondary tabs example"
      >
        {tabs?.map((tab) => (
          <Tab value={tab.value} label={tab.text} />
        ))}
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default DepositOrWithdrawTab;
